module.exports = __webpack_public_path__ + "img/product-3.a46de329.jpg";